import ImageWithFallback from '@/components/shared/ImageWithFallback';
import classNames from '@/lib/misc/classNames';
interface Props {
  mainImageSrc: string;
  badgeImageSrc?: string;
  size?: number;
  badgeSize?: number;
  className?: string;
}
const TokenImage = ({
  mainImageSrc,
  badgeImageSrc,
  size,
  badgeSize,
  className
}: Props) => {
  return <div key={mainImageSrc + badgeImageSrc} className={classNames(className, 'relative rounded-full')} data-sentry-component="TokenImage" data-sentry-source-file="TokenImage.tsx">
      <ImageWithFallback src={mainImageSrc} width={size ?? 18} height={size ?? 18} alt='main-image' className={'rounded-full object-cover'} data-sentry-element="ImageWithFallback" data-sentry-source-file="TokenImage.tsx" />
      {badgeImageSrc ? <div className='absolute -bottom-1 -right-1'>
          <ImageWithFallback src={badgeImageSrc} width={badgeSize ?? 8} height={badgeSize ?? 8} alt='badge' className={'rounded-full object-cover'} />
        </div> : null}
    </div>;
};
export default TokenImage;